import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-bar-realtime-sessions-per-minute',
  templateUrl: './bar-realtime-sessions-per-minute.component.html',
  styleUrl: './bar-realtime-sessions-per-minute.component.scss',
})
export class BarRealtimeSessionsPerMinuteComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.realTimeSessionsPerMinute$.subscribe((data) => {});

    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('barRealtimeSessionsPerMinute');
    });

    this.getChartData();
  }

  chartOptions: echarts.EChartsOption = {
    legend: { bottom: 10, show: false },
    grid: { left: 40, right: 35, top: 20, bottom: 40 },
  };

  getChartData() {
    this.analyticsService.getRealTimeSessionsPerMinute().subscribe();
  }

  get series() {
    return this.analyticsService.realTimeSessionsPerMinute$.value?.series;
  }

  get labels() {
    return this.analyticsService.realTimeSessionsPerMinute$.value?.labels;
  }
}
